import React from 'react';
import ContentSlider from '../../../components/content-slider';
import TermsValueOne from '../../../content/overview/well-resourced/term-value-one';
import TermsValueTwo from '../../../content/overview/well-resourced/term-value-two';
import TermsValueThree from '../../../content/overview/well-resourced/term-value-three';
import TermsValueFour from '../../../content/overview/well-resourced/term-value-four';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const WellResourcedLongTermValue = () => {
  const slider = {
    slides: [<TermsValueOne />, <TermsValueTwo />, <TermsValueThree />, <TermsValueFour />],
  };

  const breakpoint = [
    {
      breakpoint: 1175,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        centerMode: true,
        centerPadding: '120px',
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        centerMode: true,
        centerPadding: '40px',
        dots: true,
        arrows: false,
      },
    },
  ];
  return (
    <div className="we-resourced-page">
      <div className="container">
        <div className="container-inner">
          <ScrollPositionAnimation targetElement1="anim-3">
            <div className="right-to-left anim-3">
              <div className="title">
                <h2>Well-resourced to create long-term value</h2>
              </div>
              <div className="term-value-slider">
                <ContentSlider
                  data={slider.slides}
                  slidesToShow={4}
                  slidesToScroll={4}
                  prevBtn="blue-prev-btn"
                  nextBtn="blue-next-btn"
                  responsive={breakpoint}
                />
              </div>
            </div>
          </ScrollPositionAnimation>
        </div>
      </div>
    </div>
  );
};

export default WellResourcedLongTermValue;
